import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import * as myGlobals from 'src/app/globals';
import { ShareManagementResponseModal } from 'src/app/models/modal.model';
@Injectable()
export class ShareDetailsModalService {
  constructor(private http: HttpClient) {}

  getSharesDetails(privateShareId: string): Observable<ShareManagementResponseModal[]> {
    return this.http.get<ShareManagementResponseModal[]>(
      `${myGlobals.Config.API}/shares/shared-with-me/${privateShareId}?page=0&size=10&sortField=shareDate&sortDirection=Descending`,
    );
  }
}
